import { ConfirmationMessage, Modal } from '../../ui';
import HeaderLogo from '../../ui/icons/headerLogo';
import Navbar from '../navbar';
import styles from './header.module.css';
import React, { useEffect, useRef, useState } from 'react';
import { FaArrowRightFromBracket } from 'react-icons/fa6';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import firebaseApp from 'src/helper/firebase';
import { RootState } from 'src/redux/store';
import { closeLogoutModal, openLogoutModal } from 'src/redux/ui/actions';
import { AppDispatch } from 'src/types';

const Header = () => {
  const dispatch: AppDispatch<null> = useDispatch();
  const showLogoutModal = useSelector((state: RootState) => state.ui.showLogoutModal);
  const [displayMenu, setDisplayMenu] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef?.current &&
        buttonRef?.current &&
        !menuRef?.current?.contains(event.target) &&
        !buttonRef?.current?.contains(event.target) &&
        displayMenu
      ) {
        setDisplayMenu(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [displayMenu]);

  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      await firebaseApp.auth().signOut();
      dispatch(closeLogoutModal());
      navigate('/login');
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <header className={styles.header}>
      {displayMenu && (
        <div className={styles.menu} ref={menuRef}>
          {/* <a href="https://accountancy.radiumrocket.com">
            <span className={styles.radiumMenuSpan}>Radium </span>
            <span>Accountancy</span>
          </a> */}
          <a href="https://radiumrocket.com/">
            <span className={styles.radiumMenuSpan}>Radium </span>
            <span>Web</span>
          </a>
        </div>
      )}
      <div className={styles.container}>
        <div
          className={styles.brand}
          onClick={(event) => {
            event.stopPropagation();
            setDisplayMenu(!displayMenu);
          }}
          ref={buttonRef}
        >
          <HeaderLogo testId="header-logo" />
          <span>Radium</span>
          <span>Admin</span>
          {!displayMenu ? (
            <IoIosArrowDown className={styles.arrow} />
          ) : (
            <IoIosArrowUp className={styles.arrow} />
          )}
        </div>
        <nav className={styles.navbarContainer}>
          <Navbar iconVersion={false} />
        </nav>
        <button
          data-testid="logout-btn"
          className={styles.logout}
          onClick={() => dispatch(openLogoutModal())}
        >
          Salir
          <div className={styles.iconContainer}>
            <FaArrowRightFromBracket color={'#ffffff'} />
          </div>
        </button>
      </div>
      <Modal
        testId="confirm-logout-modal"
        styles={styles.modal}
        isOpen={showLogoutModal}
        onClose={() => dispatch(closeLogoutModal())}
      >
        <ConfirmationMessage
          title={'Cerrar sesión'}
          description={'¿Desea cerrar sesión de Radium Admin?'}
          handleConfirm={() => handleLogout()}
          handleClose={() => dispatch(closeLogoutModal())}
        />
      </Modal>
    </header>
  );
};

export default Header;
